import { formatToDdMmYyyy } from '@/utils';

import type { AsyncJob, AsyncJobEffectiveStatus, LC_AsyncJobListItemOut } from './types';


// ── Status mapping from backend values to domain values ────────────────────

const STATUS_MAP: Record<string, AsyncJobEffectiveStatus> = {
  Completado: 'completed',
  Iniciado: 'in_progress',
  Pendiente: 'pending',
  Fallido: 'failed',
  Detenido: 'stopped',
  Expirado: 'expired',
};

function resolveEffectiveStatus(item: LC_AsyncJobListItemOut): AsyncJobEffectiveStatus {
  if (item.downloadTokenExpiresAt && new Date(item.downloadTokenExpiresAt) < new Date()) {
    return 'expired';
  }
  return STATUS_MAP[item.status] ?? 'pending';
}

// ── Mapper functions ────────────────────────────────────────────────────────

export function mapAsyncJob(
  item: LC_AsyncJobListItemOut,
  typeMap: Record<string, 'export' | 'import' | 'execution'>,
  typeLabels: Record<string, string>,
): AsyncJob {
  return {
    id: item.id,
    jobType: item.jobType,
    jobTypeLabel: typeLabels[item.jobType] ?? item.jobType,
    category: typeMap[item.jobType] ?? 'execution',
    status: item.status,
    effectiveStatus: resolveEffectiveStatus(item),
    progress: item.progress,
    errorMessage: item.errorMessage,
    requesterName: item.requesterName,
    requesterEmail: item.requesterEmail,
    fileName: item.fileName,
    producesFile: item.producesFile,
    createdAt: formatToDdMmYyyy(item.createdAt),
    startedAt: item.startedAt ? formatToDdMmYyyy(item.startedAt) : null,
    completedAt: item.completedAt ? formatToDdMmYyyy(item.completedAt) : null,
    failedAttempts: item.failedAttempts,
    downloadTokenExpiresAt: item.downloadTokenExpiresAt,
  };
}

export function mapAsyncJobs(
  items: LC_AsyncJobListItemOut[],
  typeMap: Record<string, 'export' | 'import' | 'execution'>,
  typeLabels: Record<string, string>,
): AsyncJob[] {
  return items.map((item) => mapAsyncJob(item, typeMap, typeLabels));
}
